<template>
  <div class="expense__card">
    <div>
      <div class="body-2 mb-2">{{ expense.transaction_date }}</div>
      <div class="expense__card--title">{{ expense.title }}</div>
    </div>
    <div class="expense__card--amount">{{ expense.amount | currency }}</div>
  </div>
</template>

<script>
export default {
  props: {
    expense: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style lang="scss" scoped>
.expense {
  margin-bottom: 2rem;
  &__card {
    background-color: #fff;
    border-radius: 0.25rem;
    margin-bottom: 0.5rem;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &--title {
      margin-top: 0.25rem;
      font-size: 1rem;
      font-weight: 500;
      margin-right: 1.25rem;
    }
    &--amount {
      color: $danger;
      font-size: 1.25rem;
      font-weight: 500;
    }
  }
}
</style>
